import { vnApp } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app";

export class vnApp_emaki extends vnApp {

	public static readonly ROLE_NAME_ADMINISTRATOR = 1;
	public static readonly ROLE_NAME_WEBSITE_ADMINISTRATOR = 2;
	public static readonly ROLE_NAME_EDITOR = 4;
	public static readonly ROLE_NAME_WRITER = 6;
	public static readonly ROLE_NAME_ACCOUNTANT = 7;
	public static readonly ROLE_NAME_AD_MANAGER = 8;
	public static readonly ROLE_NAME_MANAGING_EDITOR = 12;
	public static readonly ROLE_NAME_PAYMENT_AUDITOR = 15;
	public static readonly ROLE_NAME_HIRING_COORDINATOR = 13;
	public static readonly ROLE_NAME_VIDEO_PRODUCER = 16;
	public static readonly ROLE_NAME_IMAGE_CREATOR = 17;
	public static readonly ROLE_NAME_FREELANCE_TRAINER = 18;
	public static readonly ROLE_NAME_SEO_OPTIMIZER = 19;
	public static readonly ROLE_NAME_CANDIDATE = 20;
	public static readonly ROLE_NAME_HIRING_MANAGER = 21;
	public static readonly ROLE_NAME_APPLICATION_REVIEWER = 22;
	public static readonly ROLE_NAME_SELF_EDITING_WRITER = 23;
	public static readonly ROLE_NAME_REPUBLISH_WRITER = 24;
	public static readonly ROLE_NAME_SOCIAL_MANAGER = 25;

	public getIsLoggedInHttpCallUrl(){

		return '/api/access/isLoggedIn/';
	}

	public isOfRole(role: Number) {
		let show = false;

		let vnApp = this;
		let roles: Array<any> = vnApp.loggedUser.user.valnet_user.roles;
		let roleIds = [];

		for (let role of roles) {
			roleIds.push(role.id);
		}
		if (roleIds.indexOf(role) > -1) {
			show = true;
		}

		return show;
	}

}



// WEBPACK FOOTER //
// ./js/components/vnApp_emaki.ts